// Utils
import { getViewBox } from '../../../../utils/svgUtils';

export const getDrawingViewBox = ({ viewBox, viewBoxX = 0, viewBoxY = 0, viewBoxWidth, viewBoxHeight }) => {
    if (viewBox) return viewBox;

    return getViewBox({ x: viewBoxX, y: viewBoxY, width: viewBoxWidth, height: viewBoxHeight });
};
